import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./groups.module.css";
import Loader from "../../../components/Loader";
import Footer from "../../../components/Footer";
import { ArrowLeft, Home, X } from "react-feather";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { TableLoaderSmall } from "../../../components/LoaderC";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import AddGroup from "./components/AddGroup";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import GroupFilter from "./components/GroupFilter";
import GroupCard from "./components/GroupCard";

const Groups = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [filterData, setFilterData] = useState({ searchKey: "", type: "" });
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectecId, setSelectecId] = useState(0);
    const [editUserData, setEditUserData] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        const getGroupList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/groups", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllData(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        getGroupList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (allData.length > 0) {
            let filteredDataTemp = allData;

            if (filterData.searchKey !== "") {
                let inputVal = filterData.searchKey;
                inputVal = inputVal.toLowerCase();
                filteredDataTemp = filteredDataTemp.filter((item) => {
                    return (item.title.toLowerCase().includes(inputVal) || item.type.toLowerCase().includes(inputVal));
                });
            }

            if (filterData.type !== "" && filterData.type !== "all") {
                filteredDataTemp = filteredDataTemp.filter((i) => i.type === filterData.type);
            }

            setFilteredData(filteredDataTemp);
        }
    }, [allData, filterData]);

    const confirmDelete = async () => {
        setDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_USER_API_URL + 'v1/campaign/groups/' + selectecId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setAllData(prev => {
                return prev?.filter(i => i?.id !== selectecId);
            });
            setSelectecId(0);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title="Manage Email Groups" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Manage Email Groups</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Campaigns</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage Email Groups</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

                    {!contentLoading && <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <GroupFilter setFilterData={setFilterData.bind(this)} setAddModalOpen={setAddModalOpen.bind(this)} />

                            <div className={`${styles.NotesRow}`}>

                                {filteredData.map((item, index) => {
                                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<GroupCard item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setSelectecId={setSelectecId.bind(this)} setEditUserData={setEditUserData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} />) : null;
                                })}

                                {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    <TablePagination
                                        count={filteredData.length}
                                        color="primary"
                                        page={page}
                                        rowsPerPage={perPage}
                                        onPageChange={(e, v) => setPage(v)}
                                        rowsPerPageOptions={[
                                            { label: "4", value: 4 },
                                            { label: "8", value: 8 },
                                            { label: "16", value: 16 },
                                            { label: "All", value: -1 },
                                        ]}
                                        onRowsPerPageChange={(e) => {
                                            setPage(0);
                                            setPerPage(e.target.value);
                                        }}
                                        labelRowsPerPage={"Devices per Page:"}
                                    />
                                </div>)}

                                {filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/no-prospect.png" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Let's get started!</p>
                                    <p className={`${styles.NoDataTextSub}`}>You don't have any groups saved.</p>
                                </div>)}

                            </div>

                        </div>
                    </div>}
                </div>
            </div>
        </div>

        <Dialog
            open={addModalOpen}
            onClose={(e) => { setAddModalOpen(false) }}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => { setAddModalOpen(false) }}><ArrowLeft /></button>
                Add Group
                <button onClick={(e) => { setAddModalOpen(false) }}><X /></button>
            </DialogTitle>
            <DialogContent>
                <AddGroup setAddModalOpen={setAddModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAllData={setAllData.bind(this)} editData={null} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={editModalOpen}
            onClose={(e) => { setEditModalOpen(false) }}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => { setEditModalOpen(false) }}><ArrowLeft /></button>
                Update Group
                <button onClick={(e) => { setEditModalOpen(false) }}><X /></button>
            </DialogTitle>
            <DialogContent>
                <AddGroup setAddModalOpen={setEditModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAllData={setAllData.bind(this)} editData={editUserData} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Would you like to delete this group?<button onClick={(e) => setDeleteModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The group information will be removed immediately.You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>);
}

export default withAuthenticationRequired(Groups, {
    onRedirecting: () => <Loader />,
});